import {
    ADD_SYSTEM_CONFIGURATION,
    GET_SYSTEM_CONFIGURATION,
    ALL_SYSTEM_CONFIGURATION,
    EDIT_SYSTEM_CONFIGURATION,
    UPLOAD_FILE,
    DOWNLOAD_FILE
 } from "./actionTypes"
 
 export const addSystemConfiguration = (data,history) => {
   return {
     type: ADD_SYSTEM_CONFIGURATION,
     payload: { data,history},
   }
 }

 export const getSystemConfiguration = (data) => {
   return {
     type: GET_SYSTEM_CONFIGURATION,
     payload: {data},
   }
 }

 export const allSystemConfiguration = data => {
   return {
     type: ALL_SYSTEM_CONFIGURATION,
     payload: data,
   }
 }

 export const editSystemConfiguration = (data,history) => {
   return {
     type: EDIT_SYSTEM_CONFIGURATION,
     payload:{data,history},
   }
 }
 export const uploadFile = (data) => {
  return {
    type: UPLOAD_FILE,
    payload:{data},
  }
}
export const downloadFile = (data) => {
  return {
    type: DOWNLOAD_FILE,
    payload:{data},
  }
}